import React from 'react'

import Header from '../components/Header'
import Footer from '../components/Footer'
import CookiesBanner from '../components/CookiesBanner'

const DashboardLayout = ({ props, children }) => {
    const pathname = props.history.location.pathname

    const hide_header_paths = []
    const show_header = hide_header_paths.indexOf(pathname) === -1

    const hide_footer_paths = ['/404']
    const show_footer = hide_footer_paths.indexOf(pathname) === -1

    return (
        <div className="main">
            {show_header ? <Header /> : null}
            <main>{children}</main>
            {show_footer ? <Footer /> : null}
            <CookiesBanner />
        </div>
    )
}

export default DashboardLayout
